const colors = {
    darkGray: '#222',
    lightGray: '#777',
    lighterGrey: '#bababd',
};

export const theme = {
    light: {
        userName: colors.darkGray,
        secondary: colors.lightGray,
    },
    dark: {
        userName: colors.lighterGrey,
        secondary: colors.lightGray,
    },
};
